import { render, staticRenderFns } from "./AskCrowdTag.vue?vue&type=template&id=1f6ac76e"
import script from "./AskCrowdTag.vue?vue&type=script&lang=js"
export * from "./AskCrowdTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports